export const ContactTypeKind = {
  PERSON: 'Person',
  COMPANY: 'Company',
  PERSON_AND_COMPANY: 'PersonAndCompany',
};

export const CONTACT_TYPE_KIND_LABELS = {
  [ContactTypeKind.PERSON]: 'Person',
  [ContactTypeKind.COMPANY]: 'Company',
  [ContactTypeKind.PERSON_AND_COMPANY]: 'Person and company',
};

export const ContactTypeExternalProvider = {
  DATA_VERIFY_DRIVE: 'DataVerifyDrive',
};

export const ContactTypeScope = {
  PICKER: 'picker',
  ALL: 'all',
};

export const DriveMappingState = {
  MAPPED: 'mapped',
  NOT_MAPPED: 'notMapped',
  NOT_SENT: 'notSent',
};

export const DriveCoverageStatus = {
  MAPPED: 'mapped',
  NOT_SENT: 'notSent',
  NO_SOURCE: 'noSource',
};

export const DRIVE_COVERAGE_STATUS_LABELS = {
  [DriveCoverageStatus.MAPPED]: 'Mapped',
  [DriveCoverageStatus.NOT_SENT]: 'Not sent',
  [DriveCoverageStatus.NO_SOURCE]: 'No source in Optimus',
};

export const MIN_SLOTS_TO_COLLAPSE = 3;
